import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import EmployeesTab from "@/pages/hr/EmployeesTab";
import AutoCountImportTab from "@/pages/hr/AutoCountImportTab";
import OrgTab from "@/pages/hr/OrgTab";
import ShiftGroupsTab from "@/pages/hr/ShiftGroupsTab";
import CalendarTab from "@/pages/hr/CalendarTab";
import ScheduleTab from "@/pages/hr/ScheduleTab";
import PayrollTab from "@/pages/hr/PayrollTab";
import AttendanceTab from "@/pages/hr/AttendanceTab";
import LeaveTab from "@/pages/hr/LeaveTab";

export default function HR() {
  const { can } = useAuth();
  const tabs = [
    { id: "employees", label: "Employees", show: can("hr:employee_view"), el: <EmployeesTab /> },
    { id: "import", label: "AutoCount Import", show: can("hr:import_autocount"), el: <AutoCountImportTab /> },
    { id: "org", label: "Organisation", show: can("hr:employee_view"), el: <OrgTab /> },
    { id: "shifts", label: "Shift Groups", show: can("hr:schedule_view"), el: <ShiftGroupsTab /> },
    { id: "calendar", label: "Company Calendar", show: can("hr:schedule_view"), el: <CalendarTab /> },
    { id: "schedule", label: "Packing Schedule", show: can("hr:schedule_view"), el: <ScheduleTab /> },
    { id: "attendance", label: "Attendance", show: can("attendance:view_team") || can("attendance:view_all"), el: <AttendanceTab /> },
    { id: "leave", label: "Leave", show: can("leave:view_team") || can("leave:view_all") || can("leave:approve") || can("leave:balance_manage") || can("leave:type_manage") || can("leave:import_autocount"), el: <LeaveTab /> },
    { id: "payroll", label: "Payroll", show: can("payroll:view") || can("payroll:process") || can("payroll:review") || can("payroll:finalize") || can("payroll:manage_profiles") || can("payroll:adjust") || can("payroll:statutory_manage") || can("payroll_history:view"), el: <PayrollTab /> },
  ].filter(t => t.show);
  const [tab, setTab] = useState(tabs[0]?.id);

  return (
    <div data-testid="hr-page">
      <header className="mb-6">
        <div className="caption">People &amp; Scheduling</div>
        <h1 className="font-heading text-3xl font-extrabold mt-1">Human Resources</h1>
        <p className="text-slate-500 mt-1 text-sm">Employee master, AutoCount import, org structure, shift groups, packing schedule &amp; historical payroll archive.</p>
      </header>
      <div className="flex gap-1 mb-5 border-b border-slate-200 flex-wrap">
        {tabs.map(t => (
          <button key={t.id} data-testid={`hr-tab-${t.id}`} onClick={() => setTab(t.id)}
            className={`px-4 py-2 text-sm font-medium border-b-2 -mb-px ${tab === t.id ? "border-slate-900 text-slate-900" : "border-transparent text-slate-500 hover:text-slate-700"}`}>{t.label}</button>
        ))}
      </div>
      {tabs.find(t => t.id === tab)?.el}
    </div>
  );
}
